import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppSP from './AppSP';
import ScrollToTopAuto from './components/ScrollToTopAuto';
import AuthProvider from './auth/contexts/AuthContext';
import CampaignProvider from './contexts/CampaignContext';
import ChatBot from './components/chat/ChatBot';

const App: React.FC = () => {
  return (
    <>
      <Router>
        <AuthProvider>
          <CampaignProvider>
            <ScrollToTopAuto />
            <AppSP />
            <ChatBot />
          </CampaignProvider>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;